import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveCardiac } from '../../procedures/cardiac/store/cardiac.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setCardiacQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addCardiacToTimeline } = quickActionsObject
  if (addCardiacToTimeline) {
    yield put(saveCardiac())
  }
}

export function* setCardiacQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_CARDIAC_TO_TIMELINE], setCardiacQuickActionTimeLineRow)
}
